import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import { PropertyLocation } from '../../@types/location'
import { Status } from '../../@types/status'
import { Resource } from '../../@types/resource'
import { fetchLocation } from './thunks'
import { GeoEntity } from '../../@types/geoEntity'

export interface LocationState extends Resource<PropertyLocation> {
  locationRange?: number
}

export const initialState: LocationState = { status: Status.LOADING, locationRange: 10 }

const createLocationFromGeoEntity = (geoEntity: GeoEntity): Resource<PropertyLocation> => {
  const { lat, lon } = geoEntity.geoData
  const { city, postcode } = geoEntity.address
  const gacId = geoEntity.id

  return {
    status: Status.SUCCESS,
    data: {
      city,
      postcode,
      gacId,
      coordinates: {
        latitude: lat,
        longitude: lon,
      },
    },
  }
}

const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    resetLocation: (state) => {
      return { ...state, status: Status.LOADING, data: undefined }
    },
    updateSuccessLocation: (state, action: PayloadAction<GeoEntity>) => {
      return { ...state, ...createLocationFromGeoEntity(action.payload) }
    },
    updateLocationRange: (state, action: PayloadAction<number>) => {
      return { ...state, locationRange: action.payload }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchLocation.fulfilled, (state, action) => {
      return { ...state, ...createLocationFromGeoEntity(action.payload) }
    })
    builder.addCase(fetchLocation.rejected, (state, action) => {
      const errorMsg = action.payload ? action.payload : action.error
      console.error(errorMsg)

      return { ...state, status: Status.ERROR }
    })
    builder.addCase(fetchLocation.pending, (state) => {
      return { ...state, status: Status.LOADING }
    })
  },
})

export const { resetLocation, updateSuccessLocation, updateLocationRange } = locationSlice.actions

export default locationSlice.reducer
